import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id 3D0AC996-0A31-4D68-AD38-A8507967B269
 * name axis-arrow
 * version: 3.4.93
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/axis-arrow.svg
 * tags
 * - Arrow 
 */
export const AxisArrowIcon = createSvgIcon(<><path d="M12,2L16,6H13V13.85L19.53,17.61L21,15.03L22.5,20.5L17,21.96L18.53,19.35L12,15.58L5.47,19.35L7,21.96L1.5,20.5L3,15.03L4.47,17.61L11,13.85V6H8L12,2Z" /></>, 'AxisArrowIcon');
export default AxisArrowIcon